import { useState, useEffect } from "react";
import { isMarketRestrictedWantAd } from "@/helpers/marketRestriction";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import _ from "lodash";
import base64 from "base-64";
import utf8 from "utf8";

// Services
import {
  saveAgentInfo,
  saveUserType_Title,
  userEmailVerification,
} from "../services/v2/signupService";
import {
  getInAppNotications,
  getIntroductions,
  updateInAppDeleteStatus,
  updateInAppReadStatus,
  updateIntroShowStatus,
} from "../services/introductionService";
import {
  resetPassword,
  updatePassword,
  verifyUserAction,
} from "../services/v2/loginService";
import { getWantAdById, unArchiveWantAd } from "../services/wantAdService";

// Helpers
import {
  clearLocalStorage,
  getLocalStorage,
  loggedInUser,
  setLocalStorage,
  clearLocalStorageOnLogout,
  getUserId,
  removeLocalStorage,
  checkTutorialDisplayStatus,
  getCurrentPath,
  getUserType,
  getCookie,
} from "../helpers/common";
import { convertToNumber } from "../helpers/validations";
import { signOutFirebase } from "../helpers/message";
import { isCurrentTenantMlsRestricted } from "../helpers/tenant";
import useAgentGitchaRestrictions from "./useAgentGitchaRestrictions";
import { triggerCrossLogout, getOtherDomain } from "../helpers/crossLoginHelper";

// Actions
import {
  fetchUserDetails,
  fetchUserPrivileges,
} from "../actions/userprofile";
import { setInappNotificationCount } from "../reducers/unReadStatus";

// Constants
import {
  USER_INFO_KEY,
  USER_TYPE_AGENT,
  USER_TYPE_MEMBER,
  WANT_AD,
  WANT_AD_ARRAY_KEY,
  INAPPNOTIFICATIONCOUNT,
  NOTIFICATIONCOUNT,
  INVENTORY_KEY,
  ONBOARDING_DISMISSED_KEY,
} from "../constants/common";
import {
  EMAIL_VERIFICATION,
  HOME,
  POST_WANT_AD,
  RESET_PWD_ACTION,
  resetModalemailOnly,
  resetModalpwdOnly,
  LOGIN,
  SIGNUP,
} from "../constants/onBoarding";
import { pageURLs } from "../constants/pageURLs";
import { useCurrentWebsite } from "./useCurrentWebsite";
import { withBase } from "@/helpers/basePath";

export const useHeaderLogic = (props) => {
  const {
    wantAdClickCounter,
    updateInventoryState,
    isMatch,
    onLoginSuccess,
  } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const tutorialPage = 4;
  const INTRO_LIST_PAGE_LIMIT = 4;
  const actionArray = ["5", "6", "7", "8", "9"];
  const excludedUrls = [pageURLs.wantAdPubicDetailsPage];

  // Selectors
  const userDetailsFromStore = useSelector((state) => state.userProfile.userDetails);
  const { sseData } = useSelector((state) => state.sseData);
  const sseTriggedData = sseData?.payload;
  let { unreadInappNotificationCount, messageCount: unreadChatCount, dmMessageCount } = useSelector((state) => state.unreadCount);
  unreadInappNotificationCount = unreadInappNotificationCount?.payload;

  // User state
  const state = location.state;
  const user = loggedInUser();
  const userId = searchParams.get("Id");
  const gCode = searchParams.get("g_code");
  const action = searchParams.get("action");
  const isFromSettings = searchParams.get("isFromSettings");
  const UserId =
    _.get(user, "userInfo.userId", null) ||
    _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", null);
  const userData = getLocalStorage(USER_INFO_KEY);
  const currentURL = getCurrentPath();

  // State management
  const [userDetails, setUserDetails] = useState(null);
  const [email, setEmail] = useState("");
  const [userPreference, setUserPreference] = useState("");
  const [agentTitleModalShow, setAgentTitleModal] = useState(false);
  const [userTypeModalShow, setUserTypeModal] = useState(false);
  const [agentProfileModal, setAgentProfileModal] = useState(false);
  const [memberProfileModal, setMemberProfileModal] = useState(false);
  const [selectedTitle, setTitle] = useState();
  const [userType, setUserType] = useState();
  const [titleContinueState, setTitleButtonState] = useState();
  const [isDisabledUserContinue, setUserTypeContinueButton] = useState(true);
  const [agentPreference, setAgentPreference] = useState();
  const [showEmailVerifiedModal, setShowEmailVerifiedmodal] = useState(false);
  const [showEmailConfirmedModal, setShowEmailConfirmedModal] = useState(false);
  const [showEmailChangeRevokedModal, setShowEmailChangeRevokedModal] = useState(false);
  const [isLoadIntroList, setLoadIntroList] = useState(false);
  const [introductionList, setIntroductionList] = useState([]);
  const [currPage, setCurrPage] = useState(1);
  const [showIntroList, setIntroList] = useState(true);
  const [checkEmailPopup, setCheckEmailPopup] = useState(false);
  const [emailNotVerified, setEmailNotVerified] = useState(false);
  const [showPremiumPlanModal, setPremiumPlanModal] = useState(false);
  const [showBasicPlanModal, setBasicPlanModal] = useState(false);
  const [reload, setReload] = useState(0);
  const [agentOnboardingPopup, setAgentOnboardingPopup] = useState({});
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);
  const [resetPwdModal, setResetPwdModal] = useState(false);
  const [resetPwdModalType, setResetModalType] = useState(resetModalemailOnly);
  const [resetEmailModalState, setResetEmailState] = useState(false);
  const [isLoadNotificationList, setLoadNotificationList] = useState(false);
  const [notificationList, setNotificationList] = useState([]);
  const [deleteNotificationModal, setDeleteNotificationModal] = useState(false);
  const [wantAdRenewModal, setWantAdRenewModal] = useState(false);
  const [wantAdForRenew, setWantAdForReniew] = useState(null);
  const [unreadNotificationMessageCount, setUnreadNotificationMessageCount] = useState(0);
  const [userPlan, setUserPlan] = useState("");
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(
    state && state.deleteAccount === true ? true : false
  );
  const [contactModalState, setContactModalState] = useState(false);
  const [showAgentMenuNotificationIcon, setAgentMenuNotificationIcon] = useState(false);
  const [sessionData, setSessionData] = useState(getLocalStorage(USER_INFO_KEY));
  const [image, setImage] = useState(null);
  const [showPofileImageUploadModal, setShowPofileImageUploadModal] = useState(false);
  const [reRenderEditProfileModel, setReRenderEditProfileModel] = useState(0);
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");

  const showAgentIcon = checkTutorialDisplayStatus(tutorialPage);

  // Modal handlers
  const PremiumPlanModalClose = () => setPremiumPlanModal(false);
  const PremiumPlanModalShow = () => setPremiumPlanModal(true);
  const BasicPlanModalClose = () => setBasicPlanModal(false);
  const BasicPlanModalShow = () => setBasicPlanModal(true);
  const handleDeleteNotificationPopupClose = () => setDeleteNotificationModal(false);
  const handleWantAdRenewPopupClose = () => setWantAdRenewModal(false);
  const ContactModalClose = () => setContactModalState(false);
  const ContactModalShow = () => setContactModalState(true);
  const ShowPofileImageUploadModalClose = () => setShowPofileImageUploadModal(false);
  const ShowPofileImageUploadModalShow = () => setShowPofileImageUploadModal(true);

  useEffect(() => {
    if (sseTriggedData?.messageType === "in-app") {
      getNotificationList();
      if (sseTriggedData?.subjectType === 12) {
        const pathName = _.get(location, "pathname", null);
        if (pathName && pathName.startsWith(pageURLs.inventoryDetails)) {
          const inventoryId = _.get(getLocalStorage(INVENTORY_KEY), "inventoryId", null);
          if (inventoryId) {
            updateInventoryState(inventoryId);
          }
        }
      }
    } else if (sseTriggedData?.messageType === "receiveIntroduction") {
      const wantAdId = null;
      getIntroductionList(currPage, wantAdId);
    }
  }, [sseTriggedData]);

  useEffect(() => {
    setSessionData(userData);
  }, [userData?.userInfo?.ClientCount]);

  useEffect(() => {
    if (userType) {
      setUserTypeContinueButton(false);
    } else {
      setUserTypeContinueButton(true);
    }
  }, [userType]);

  useEffect(() => {
    const userId = getUserId();
    if (userId) {
      dispatch(fetchUserDetails());
    }
  }, [reload]);

  useEffect(() => {

    const IsFromMarketing = searchParams.get("IsFromMarketing");
    const userType = _.get(userData, "userInfo.userType", null);
    const utm_source = searchParams.get("utm_source");
    const utm_medium = searchParams.get("utm_medium");
    const utm_campaign = searchParams.get("utm_campaign");

    if (utm_source || utm_medium || utm_campaign) {
      setLocalStorage("utmData", {
        utm_source,
        utm_medium,
        utm_campaign,
      });
    }

    if (IsFromMarketing) {
      const userAction = searchParams.get("userAction");
      const userActionLogin = "LOGIN";
      const userActionSignUp = "SIGNUP";
      const userActionCreateWantAd = "POSTWANTAD";
      const userActionCreateAgentInvtry = "CREATE_AGENT_INVENTORY";
      const userActionCreateMemberInvtry = "CREATE_MEMBER_INVENTORY";
      const userActionBrowseWantAd = "BROWSE_WANT_AD";
      const location = searchParams.get("location");

      if (location) {
        setLocalStorage("LocationString", location);
        navigate(pageURLs.home);
      }

      if (!userType) {
        let utmDtata = getLocalStorage("utmData");
        handleAgentOnboardingModal({
          showPopup: true,
          userAction: userAction === userActionLogin ? userActionLogin : userActionSignUp,
          utm_source: utmDtata?.utm_source,
          utm_medium: utmDtata?.utm_medium,
          utm_campaign: utmDtata?.utm_campaign,
        });
        if (userAction === userActionCreateWantAd) {
          setLocalStorage("userAction", userAction);
        }
        navigate(pageURLs.home);
      } else {
        if (userAction === userActionCreateWantAd) {
          if (userType === USER_TYPE_AGENT) {
            navigate(pageURLs.agentCreatewantad);
          } else {
            navigate(pageURLs.agentCreatewantad);
          }
        } else if (
          userAction === userActionCreateAgentInvtry ||
          userAction === userActionCreateMemberInvtry
        ) {
          if (userType === USER_TYPE_AGENT) {
            navigate(pageURLs.agentCreateInventory);
          } else {
            navigate(pageURLs.memberCreateInventory);
          }
        } else if (
          userAction === userActionLogin ||
          userAction === userActionSignUp ||
          userAction === userActionBrowseWantAd
        ) {
          navigate(pageURLs.home);
        }
      }
    } else if (showDeleteConfirmationModal) {
      setCheckEmailPopup(true);
    } else if (convertToNumber(action) === RESET_PWD_ACTION && userId) {
      if (userId) {
        handleResetPwdModal({
          showResetModal: true,
          resetPwdModalType: resetModalpwdOnly,
          token: gCode,
          action: action,
        });
      }
    } else if (convertToNumber(action) === EMAIL_VERIFICATION && userId) {
      const decryptedKey = decryption(userId);
      if (decryptedKey) {
        const reqPayload = {
          action: action,
          token: gCode,
          userId: decryptedKey,
          isEmailVerified: 1,
        };
        emailVerification(reqPayload);
      }
    } else {
      handleUserLogin();
    }
  }, [isMatch]);

  useEffect(() => {
    if (wantAdClickCounter && wantAdClickCounter !== 0) {
      const userDetails = getLocalStorage(USER_INFO_KEY);
      const isVerified = _.get(userDetails, "userInfo.userIsVerified", null);
      const planStatus = _.get(userDetails, "userInfo.planStatus", null);
      const userStatus = _.get(userDetails, "userInfo.userStatus", null);
      if (!isVerified || !planStatus || !userStatus) {
        const wantAdArray = getLocalStorage(WANT_AD_ARRAY_KEY);
        if (wantAdArray && wantAdArray.length === 3) {
          handleAgentOnboardingModal({
            showPopup: isMatch ? true : false,
            userAction: SIGNUP,
          });
        }
      }
    }
  }, [wantAdClickCounter, isMatch]);

  useEffect(() => {
    if (userDetailsFromStore !== null && userDetailsFromStore?.length > 0) {
      const activePlan =
        userDetailsFromStore.find((pl) => pl?.Is_Upcoming === 0 && pl?.IsActive === 1,) ||
        (userDetailsFromStore[0]?.PlanName === "Trial" && userDetailsFromStore?.length > 1
          ? userDetailsFromStore[1]
          : userDetailsFromStore[0]);

      setUserDetails(activePlan);
      if (activePlan?.PlanName) {
        setUserPlan(activePlan.PlanName);
      }
    } else {
      setUserDetails(null);
    }
  }, [userDetailsFromStore]);

  useEffect(() => {
    if (!UserId) return;
    const payload = {
      PlanId: userDetails?.PlanId,
    };
    dispatch(fetchUserPrivileges(payload));
  }, [userDetails?.PlanId, UserId]);

  useEffect(() => {
    if (gCode && actionArray.includes(action)) {
      const reqPayLoad = {
        VerifyCode: gCode,
        Action: parseInt(action),
        IsVerified: 1,
      };

      try {
        verifyUserAction(reqPayLoad).then((response) => {
          if (response.errorCode === 0) {
            if (action === "8") {
              clearLocalStorage();
              navigate(pageURLs.home);
              toast.success("Account successfully deleted.");
            } else if (action === "5") {
              if (response?.result?.Status === "Confirmed") {
                handleEmailConfirmedModalOpen();
              } else {
                handleEmailVerifiedModalOpen();
              }
            } else if (action === "6") {
              clearLocalStorage();
              if (response?.result?.Status === "New_Email_Not_Verified") {
                setEmailNotVerified(true);
              } else {
                setEmailNotVerified(false);
              }
              handleEmailConfirmedModalOpen();
            } else if (action === "7") {
              clearLocalStorage();
              handleEmailChangeRevokedModalOpen();
            } else if (action === "9") {
              clearLocalStorage();
              toast.success("Account deletion revoked successfully.");
            }
          } else {
            toast.dismiss();
            toast.error(response.message);
          }
        });
      } catch (error) {
        toast.dismiss();
        toast.error(error);
      }
    }
  }, [action]);


  useEffect(() => {
    if (!UserId) return;
    const wantAdId = null;
    currPage !== 1 && getIntroductionList(currPage, wantAdId);
  }, [currPage, UserId]);

  useEffect(() => {
    if (!UserId) return;
    const wantAdId = null;
    setCurrPage(1);
    getIntroductionList(1, wantAdId, true);
  }, [UserId]);

  useEffect(() => {
    unreadNotificationMessageCount > 0 &&
      setLocalStorage(INAPPNOTIFICATIONCOUNT, {
        count: unreadNotificationMessageCount,
      });
    unreadMessageCount > 0 &&
      setLocalStorage(NOTIFICATIONCOUNT, { count: unreadMessageCount });
  }, [unreadNotificationMessageCount, unreadMessageCount]);

  useEffect(() => {
    if (
      showAgentIcon === true &&
      sessionData &&
      sessionData?.userInfo?.ClientCount > 0
    ) {
      setAgentMenuNotificationIcon(true);
    }
  }, [sessionData, sessionData?.userInfo?.ClientCount]);

  // Helper functions
  const decryption = (value) => {
    const bytes = base64.decode(value);
    const decodedId = utf8.decode(bytes);
    if (decodedId) {
      const decodedData = decodedId.split("-");
      return decodedData.length > 0 ? decodedData[1] : null;
    }
    return null;
  };

  const emailVerification = async (reqPayload) => {
    await userEmailVerification(reqPayload).then((response) => {
      if (response) {
        const errorCode = _.get(response, "errorCode", null);
        if (errorCode === 0) {
          toast.success("Email verified Successfully.");
        } else {
          toast.error("Something went wrong");
        }
      }
    });
  };

  // Modal handlers
  const handleUserTypeModal = ({ showModal }) => {
    // A deliberate open clears an earlier "later" so setup stays reachable.
    if (showModal) removeLocalStorage(ONBOARDING_DISMISSED_KEY);
    setUserTypeModal(showModal);
  };

  // Persisted: this auto-opens on every load, so a refresh would re-trap.
  const handleUserTypeModalDismiss = () => {
    setLocalStorage(ONBOARDING_DISMISSED_KEY, true);
    setUserTypeModal(false);
  };

  const handleAgentTitleModal = ({ showModal }) => {
    if (showModal) removeLocalStorage(ONBOARDING_DISMISSED_KEY);
    setAgentTitleModal(showModal);
  };

  const handleAgentTitleModalDismiss = () => {
    setLocalStorage(ONBOARDING_DISMISSED_KEY, true);
    setAgentTitleModal(false);
  };

  const handleMemberProfileModal = ({ showModal }) => {
    setMemberProfileModal(showModal);
  };

  const handleShowAgentModal = ({ showState }) => {
    setAgentProfileModal(showState);
  };

  const handleEmailVerifiedModalClose = () => {
    setShowEmailVerifiedmodal(false);
  };

  const handleEmailVerifiedModalOpen = () => {
    setShowEmailVerifiedmodal(true);
  };

  const handleEmailConfirmedModalClose = () => {
    setShowEmailConfirmedModal(false);
  };

  const handleEmailConfirmedModalOpen = () => {
    setShowEmailConfirmedModal(true);
  };

  const handleEmailChangeRevokedModalClose = () => {
    setShowEmailChangeRevokedModal(false);
  };

  const handleEmailChangeRevokedModalOpen = () => {
    setShowEmailChangeRevokedModal(true);
  };

  const handleCheckEmailDeletionModalClose = () => {
    setCheckEmailPopup(false);
    navigate(pageURLs.home, {});
    window.location.reload();
  };

  const handleResetEmailModal = ({ modalState }) => {
    setResetEmailState(modalState);
  };

  const updateReloadParam = () => {
    setReload(reload + 1);
  };

  const renderEditProfileModel = (uploadedImageUrl) => {
    setUploadedImageUrl(uploadedImageUrl);
    setReRenderEditProfileModel(reRenderEditProfileModel + 1);
  };

  // Business logic functions
  const saveUserTypeAndTitle = async (reqPayload) => {
    return await saveUserType_Title(reqPayload).then((response) => {
      return response;
    });
  };

  const handleAgentTitleContinueClick = async () => {
    const reqPayload = {
      title: selectedTitle,
    };

    const res = await saveUserTypeAndTitle(reqPayload);
    if (_.get(res, "errorCode", "") === 0) {
      const userDetails = getLocalStorage(USER_INFO_KEY);
      userDetails.userInfo.agentTitle = convertToNumber(selectedTitle);
      setLocalStorage(USER_INFO_KEY, userDetails);
      navigate(pageURLs.selectYourPlan);
    } else {
      alert("Something went wrong.");
    }
  };

  const handleUserTypeContinueClick = async () => {
    const selectedUserType = userType || _.get(userData, "userInfo.userType", null);
    const reqPayload = {
      userTypeId: selectedUserType,
    };

    const res = await saveUserTypeAndTitle(reqPayload);

    if (_.get(res, "errorCode", "") === 0) {
      const userDetails = getLocalStorage(USER_INFO_KEY);
      userDetails.userInfo.userType = convertToNumber(selectedUserType);
      setLocalStorage(USER_INFO_KEY, userDetails);
      handleUserTypeModal({ showModal: false });
      if (convertToNumber(selectedUserType) === USER_TYPE_AGENT) {
        handleAgentTitleModal({ showModal: true });
      } else {
        BasicPlanModalShow();
      }
    } else {
      alert("Something went wrong.");
    }
  };

  const handleResetPwdModal = ({
    showResetModal,
    resetPwdModalType,
    userId,
    token = "",
    action = "",
  }) => {
    handleAgentOnboardingModal({
      showPopup: false,
      userAction: LOGIN,
    });
    setResetModalType(resetPwdModalType);
    setResetPwdModal({
      showResetModal: showResetModal,
      userId: userId,
      token: token,
      action: convertToNumber(action),
    });
  };

  const handleAgentOnboardingModal = (params) => {

    const showPopup = _.get(params, "showPopup", false);
    const userPreference = _.get(params, "userPreference", null);
    const userAction = _.get(params, "userAction", null);

    const currentParams = new URLSearchParams(window.location.search);

    if (showPopup) {
      if (userAction === LOGIN) {
        currentParams.set("auth", "login");
      } else if (userAction === SIGNUP) {
        currentParams.set("auth", "signup");
      }
    } else {
      currentParams.delete("auth");
    }

    const queryString = currentParams.toString();
    const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ""}`;
    window.history.pushState({}, "", newUrl);

    if (userPreference) {
      setUserPreference(userPreference);
    } else {
      setUserPreference(HOME);
    }

    setAgentOnboardingPopup((prevData) => ({ ...prevData, params }));
  };

  const resetPassWord = async (params) => {
    const email = _.get(params, "email", null);
    if (email) {
      return await resetPassword(params).then((response) => {
        if (response) {
          const resResult = _.get(response, "result", null);
          if (_.get(response, "errorCode", null) === 0) {
            setResetEmailState(true);
            setResetPwdModal({ showResetModal: false });
            setEmail(email);
          } else {
            return { isVerified: false, message: response?.message };
          }
        }
        return { isVerified: false, message: "something went wrong." };
      });
    } else {
      return await updatePassword(params).then((response) => {
        if (response) {
          if (_.get(response, "errorCode", "") === 0) {
            setResetPwdModal({ showResetModal: false });
            if (isFromSettings) {
              toast.success("Password changed successfully.");
            } else {
              handleAgentOnboardingModal({
                showPopup: true,
                userAction: LOGIN,
              });
              toast.success("Password changed successfully, please login again.");
            }
          } else {
            return response;
          }
        }
        return null;
      });
    }
  };

  const handleUserLogin = () => {

    const userDetails = getLocalStorage(USER_INFO_KEY);
    const userType = _.get(userDetails, "userInfo.userType", null);
    const agentTitle = _.get(userDetails, "userInfo.agentTitle", null);
    const isVerified = _.get(userDetails, "userInfo.userIsVerified", null);
    const planStatus = _.get(userDetails, "userInfo.planStatus", null);
    const userStatus = _.get(userDetails, "userInfo.userStatus", null);
    const userActionForwarded = getLocalStorage("userAction");


    if (userDetails?.userInfo) {
      if (userType) {
        if (isVerified && planStatus && userStatus) {
          onLoginSuccess?.();
          if (userActionForwarded === "POSTWANTAD") {
            if (userType === USER_TYPE_AGENT) {
              navigate(pageURLs.agentCreatewantad);
            } else {
              navigate(pageURLs.agentCreatewantad);
            }
          } else {
            removeLocalStorage(WANT_AD_ARRAY_KEY);
            if (userPreference && userPreference === POST_WANT_AD) {
              navigate(pageURLs.agentCreatewantadMainScreen);
            } else if (userPreference && userPreference === HOME) {
              navigate(pageURLs.home);
            }
          }
        } else {
          if (convertToNumber(userType) === USER_TYPE_AGENT) {
            if (isCurrentTenantMlsRestricted()) {
              // BLS tenants are pre-verified MLS agent seats - skip the
              // Gitcha onboarding cascade (AgentTitle modal, plan select,
              // profile completion) and drop them on the feed.
              onLoginSuccess?.();
              navigate(pageURLs.home);
            } else if (!agentTitle) {
              // Not handleAgentTitleModal: an auto-open must not clear the flag.
              if (!getLocalStorage(ONBOARDING_DISMISSED_KEY)) {
                setAgentTitleModal(true);
              }
            } else if (!planStatus) {
              navigate(pageURLs.selectYourPlan);
            } else if (!userStatus) {
              navigate(pageURLs.completeYourProfileDefault);
            }
          } else {
            if (!planStatus) {
              BasicPlanModalShow();
            } else if (!userStatus) {
              handleMemberProfileModal({ showModal: true });
            }
          }
        }
      } else {
        const pendingProfile = getLocalStorage("pendingCreateProfile");
        const dismissed = getLocalStorage(ONBOARDING_DISMISSED_KEY);
        if (!pendingProfile && !dismissed) {
          setUserTypeModal(true);
        }
      }
    } else {
      const pathName = _.get(location, "pathname", null)?.toLowerCase();
      if (!_.includes(excludedUrls, pathName)) {
        let utmDtata = getLocalStorage("utmData");
        if (
          !pathName.startsWith(pageURLs.wantAdDetails) &&
          !pathName.startsWith(pageURLs.agentInfo) &&
          pathName !== `${pageURLs.wantAdPubicDetailsPage}/${pageURLs.deletedWantAd}`
        ) {
          handleAgentOnboardingModal({
            showPopup: isMatch ? true : false,
            userAction: SIGNUP,
            userPreference: HOME,
            utm_source: utmDtata?.utm_source,
            utm_medium: utmDtata?.utm_medium,
            utm_campaign: utmDtata?.utm_campaign,
          });
        }
        if (
          pathName !== "/home" &&
          pathName !== `${pageURLs.wantAdPubicDetailsPage}/${pageURLs?.deletedWantAd}` &&
          !pathName.startsWith("/want-listing-details") &&
          !pathName.startsWith("/agent-info")
        ) {
          navigate(pageURLs?.home);
        }
      }
    }
  };

  const updateIntroStateonHover = async (introId) => {
    let introIds = [];
    let readType = 1;
    if (!introId) {
      readType = 2;
    } else {
      introIds.push(introId);
      readType = 1;
    }
    await updateIntroShowStatus(
      introIds,
      readType,
      _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", "")
    ).then((response) => {
      if (response) {
        if (response.errorCode === 0) {
          if (introId) {
            const updatedIntro = introductionList.filter(
              (lst) => lst.IntroductionId === introId
            );
            if (updatedIntro) {
              updatedIntro[0].ReadStatus = 1;
            }
            const RemainingIntro = introductionList.filter(
              (lst) => lst.IntroductionId !== introId
            );
            setIntroductionList([...updatedIntro, ...RemainingIntro]);
            setUnreadMessageCount(unreadMessageCount - 1);
          } else {
            const introListCopy = introductionList;
            for (var i = 0; i < introListCopy.length; i++) {
              if (introListCopy[i].ReadStatus === 0) {
                introListCopy[i].ReadStatus = 1;
              }
            }
            setIntroductionList([...introListCopy]);
            setUnreadMessageCount(0);
          }
        } else {
          console.log("Something went wrong");
        }
      }
    });
  };

  const updateIntroPageOnScroll = () => {
    setCurrPage((prevState) => prevState + 1);
  };

  const handleCloseIntroList = () => {
    setIntroList(false);
  };

  const getIntroductionList = async (page, wantAdId, isHandShakeClick = false) => {
    setLoadIntroList(false);
    const reqPayload = {
      wantAdId: wantAdId,
      page: page,
      limit: INTRO_LIST_PAGE_LIMIT,
      isAccept: "1",
    };
    await getIntroductions(reqPayload).then((response) => {
      if (response) {
        const list = _.get(response, "result.List", null);
        if (response.errorCode === 0) {
          if (isHandShakeClick) {
            setIntroductionList(list);
            if (_.get(response, "result.unReadMessageCount", null) == 0) {
              setLocalStorage(NOTIFICATIONCOUNT, {
                count: _.get(response, "result.unReadMessageCount", null),
              });
            }
            setUnreadMessageCount(_.get(response, "result.unReadMessageCount", 0));
          } else {
            setIntroductionList([...introductionList, ...list]);
            if (_.get(response, "result.unReadMessageCount", null) == 0) {
              setLocalStorage(NOTIFICATIONCOUNT, {
                count: _.get(response, "result.unReadMessageCount", null),
              });
            }
            setUnreadMessageCount(_.get(response, "result.unReadMessageCount", 0));
          }
          setLoadIntroList(true);
        } else {
          setLoadIntroList(true);
        }
      }
    });
  };

  const handleHandShakeClick = () => {
    const wantAdId = null;
    const isHandShakeClick = true;
    const page = 1;
    setCurrPage(1);
    getIntroductionList(page, wantAdId, isHandShakeClick);
  };

  const getNotificationList = async () => {
    setLoadNotificationList(false);
    const userId = _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", "");
    await getInAppNotications().then((response) => {
      if (response) {
        const list = _.get(response, "result.List", null);

        if (response.errorCode === 0) {
          setNotificationList(list);
          if (_.get(response, "result.unReadMessageCount", null) == 0) {
            setLocalStorage(INAPPNOTIFICATIONCOUNT, {
              count: _.get(response, "result.unReadMessageCount", null),
            });
          }
          setUnreadNotificationMessageCount(
            _.get(response, "result.unReadMessageCount", null)
          );

          dispatch(
            setInappNotificationCount(_.get(response, "result.unReadMessageCount", 0))
          );

          setLoadNotificationList(true);
        } else {
          setLoadNotificationList(true);
        }
      }
    });
  };

  const updateInAppStatusonHover = async () => {
    setDeleteNotificationModal(false);
    setWantAdRenewModal(false);
    await updateInAppReadStatus().then((response) => {
      if (response) {
        if (response.errorCode === 0) {
          setUnreadNotificationMessageCount(0);
          getNotificationList();
        } else {
          console.log("Something went wrong");
        }
      }
    });
  };

  const updateInAppDeleteStatusOnClick = async (
    notificationId = null,
    subjectType,
    deleteStatus = true,
    deleteType = 2
  ) => {
    const userId = _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", "");
    await updateInAppDeleteStatus(
      notificationId,
      deleteStatus,
      deleteType,
      subjectType
    ).then((response) => {
      if (response) {
        if (response.errorCode === 0) {
          if (deleteType == 1) {
            const RemainingNotification = notificationList.filter(
              (lst) => lst.NotificationId !== notificationId
            );
            setNotificationList([...RemainingNotification]);
          } else if (subjectType != null) {
            // A digest row (reminder types with UnreadCount > 1) has no
            // single NotificationId to delete by - the caller passes
            // deleteType !== 1 with notificationId null, same as the global
            // "Clear All" action below, but WITH a subjectType. Scope the
            // local update to just that type instead of wiping the whole
            // list, and re-fetch to get the authoritative badge count
            // (unreadNotificationMessageCount is otherwise only ever set
            // from a fresh getNotificationList() response, never derived
            // locally).
            const RemainingNotification = notificationList.filter(
              (lst) => lst.SubjectType !== subjectType
            );
            setNotificationList([...RemainingNotification]);
            getNotificationList();
          } else {
            setDeleteNotificationModal(false);
            setNotificationList([]);
            setUnreadNotificationMessageCount(0);
          }

          // Same toast+undo affordance for a digest dismiss (deleteType !== 1
          // with a subjectType) as the single-row path above - a digest
          // removes more rows than a singular dismiss, so it's the case a
          // misclick costs the most, and the API already restores every row
          // of that subjectType on undo. Only the toast is added here for
          // the digest case, not another getNotificationList() call on undo -
          // the digest branch above already fetches unconditionally, so
          // calling it again here would just be a duplicate request.
          const isDigestDelete = deleteType != 1 && subjectType != null;
          if (deleteStatus == true && (deleteType == 1 || isDigestDelete)) {
            toast.dismiss();
            setTimeout(() => {
              toast.success(
                toastCustomMessage(notificationId, subjectType, deleteStatus, deleteType)
              );
            }, 10);
          } else if (deleteStatus == false && deleteType == 1) {
            getNotificationList();
          }
        }
      }
    });
  };

  const toastCustomMessage = (notificationId, subjectType, deleteStatus, deleteType) => {
    return (
      <div className="d-flex align-items-center justify-content-between">
        <span className="d-flex flex-grow-1">Notification deleted</span>
        <button
          variant=""
          className="btn-primary text-nowrap me-2"
          onClick={() => {
            updateInAppDeleteStatusOnClick(
              notificationId,
              subjectType,
              !deleteStatus,
              deleteType
            );
          }}
        >
          Undo
        </button>
      </div>
    );
  };

  const onDeleteInappNotification = () => {
    setDeleteNotificationModal(true);
  };

  const onConfirmReniewWantAdClicked = async () => {
    // GTCH-853: this market posts through the BLS, so the listing stays
    // archived. Renewing it would be refused by the server.
    if (isMarketRestrictedWantAd(wantAdForRenew)) {
      setWantAdRenewModal(false);
      toast.error(
        "Want-Listings in this market are managed through The Buyer Listing Service® and can't be re-activated here."
      );
      return;
    }
    if (wantAdForRenew?.Want_ad_Id) {
      if (
        (wantAdForRenew?.Buy_or_Rent == 2 && wantAdForRenew?.Move_in_TimeLine == 11) ||
        wantAdForRenew?.Buy_or_Rent == 3
      ) {
        await getWantAdById(wantAdForRenew?.Want_ad_Id)
          .then((response) => {
            const responseResult = _.get(response, "result", null);
            if (response.errorCode === 0 && responseResult) {
              if (responseResult.isAgentCreated == 1) {
                navigate(`${pageURLs.editWantAdForAgents}/${responseResult.wantAdId}`, {
                  state: { data: responseResult, isFromNotification: true },
                });
              } else {
                navigate(pageURLs.agentEditwantad, {
                  state: { data: responseResult },
                });
              }
            } else {
              console.log("Something went wrong");
            }
          })
          .catch((err) => {
            console.log("Error", err);
          });
      } else {
        await unArchiveWantAd(wantAdForRenew?.Want_ad_Id)
          .then((response) => {
            if (response.errorCode == 0) {
              setWantAdRenewModal(false);
              getNotificationList();
              if (wantAdForRenew?.IsArchived || wantAdForRenew?.IsAutoArchived) {
                toast.success("Your paused want-listing has been made public again.");
              } else {
                toast.success("Your want-listing has been successfully renewed.");
              }
            } else {
              console.log("Something went wrong");
            }
          })
          .catch((err) => {
            console.log("Error", err);
          });
      }
    }
  };

  const renewWantAd = async (notification) => {
    if (notification?.wantDeleted) {
      toast.success("Your want-listing has already been deleted.");
    } else if (notification?.Expiry_Status) {
      toast.success("Your want-listing already been renewed.");
    } else {
      setWantAdForReniew(notification);
      setWantAdRenewModal(true);
    }
  };

  const handleTitleClick = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue) {
      setTitle(selectedValue);
      setTitleButtonState(true);
    } else {
      setTitleButtonState(false);
    }
  };

  const handleUserTypeSelection = (e) => {
    const selectedValue = e.target.value;
    setUserType(selectedValue);
  };

  const handlePreferenceSelection = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue) {
      setAgentPreference(selectedValue);
    }
  };

  const saveAgentDetails = async (agentDetails) => {
    const userId =
      _.get(user, "userInfo.userId", null) ||
      _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", null);
    const firstName = _.get(agentDetails, "firstName", "");
    const lastName = _.get(agentDetails, "lastName", "");
    const name = firstName + " " + lastName;
    const agentInfo = {
      FirstName: firstName,
      LastName: lastName,
      Phone: _.get(agentDetails, "phone", ""),
      Location: _.get(agentDetails, "location", ""),
      Company: _.get(agentDetails, "company", ""),
      LicenseNo: _.get(agentDetails, "licenseNo", ""),
      Bio: _.get(agentDetails, "bio", ""),
      Img: _.get(agentDetails, "img", ""),
      facebookUrl: _.get(agentDetails, "facebookUrl", ""),
      instagramUrl: _.get(agentDetails, "instagramUrl", ""),
      websiteUrl: _.get(agentDetails, "websiteUrl", ""),
      logoUrl: _.get(agentDetails, "logoUrl", ""),
      clientTestimonial: _.get(agentDetails, "clientTestimonial", ""),
      youtubeUrl: _.get(agentDetails, "youtubeUrl", ""),
    };
    await saveAgentInfo(agentInfo).then((response) => {
      if (response) {
        if (response.errorCode === 0) {
          const userDetails = getLocalStorage(USER_INFO_KEY);
          if (userDetails) {
            userDetails.userInfo.userStatus = true;
            userDetails.userInfo.firstName = firstName;
            userDetails.userInfo.lastName = lastName;
            userDetails.userInfo.name = name;
            userDetails.userInfo.image = _.get(agentDetails, "img", "");
          }
          setLocalStorage(USER_INFO_KEY, userDetails);
          setAgentProfileModal(false);
        } else {
          console.log("Something went wrong");
        }
      }
    });
  };

  const handleLogOut = () => {
    const otherDomain = getOtherDomain();
    clearLocalStorageOnLogout();
    signOutFirebase();

    const returnUrl = window.location.origin + withBase("/");
    const didCrossLogout = triggerCrossLogout(returnUrl, otherDomain);
    if (!didCrossLogout) {
      setTimeout(() => {
        navigate(0);
      }, 300);
    }
  };

  const { shouldRestrictAgent } = useAgentGitchaRestrictions()

  const shouldDisplayWantListingButton = [
    currentURL !== pageURLs?.agentCreatewantad,
    currentURL !== pageURLs?.agentEditwantad,
    !currentURL?.startsWith(pageURLs.editWantAdForAgents),
    currentURL !== pageURLs?.agentCreatewantadMainScreen,
    currentURL !== pageURLs?.agentWantAdConfirmation,
    getUserType() === USER_TYPE_AGENT,
    !shouldRestrictAgent
  ].every(Boolean);

  return {
    // State
    user,
    userData,
    UserId,
    userDetails,
    email,
    userPreference,
    agentTitleModalShow,
    userTypeModalShow,
    agentProfileModal,
    memberProfileModal,
    selectedTitle,
    userType,
    titleContinueState,
    isDisabledUserContinue,
    agentPreference,
    showEmailVerifiedModal,
    showEmailConfirmedModal,
    showEmailChangeRevokedModal,
    isLoadIntroList,
    introductionList,
    currPage,
    showIntroList,
    checkEmailPopup,
    emailNotVerified,
    showPremiumPlanModal,
    showBasicPlanModal,
    reload,
    agentOnboardingPopup,
    unreadMessageCount,
    resetPwdModal,
    resetPwdModalType,
    resetEmailModalState,
    isLoadNotificationList,
    notificationList,
    deleteNotificationModal,
    wantAdRenewModal,
    wantAdForRenew,
    unreadNotificationMessageCount,
    unreadInappNotificationCount,
    unreadChatCount,
    dmMessageCount,
    userPlan,
    showDeleteConfirmationModal,
    contactModalState,
    showAgentMenuNotificationIcon,
    sessionData,
    image,
    showPofileImageUploadModal,
    reRenderEditProfileModel,
    uploadedImageUrl,
    currentURL,
    shouldDisplayWantListingButton,
    // Modal handlers
    PremiumPlanModalClose,
    PremiumPlanModalShow,
    BasicPlanModalClose,
    BasicPlanModalShow,
    handleDeleteNotificationPopupClose,
    handleWantAdRenewPopupClose,
    ContactModalClose,
    ContactModalShow,
    ShowPofileImageUploadModalClose,
    ShowPofileImageUploadModalShow,
    handleUserTypeModal,
    handleUserTypeModalDismiss,
    handleAgentTitleModal,
    handleAgentTitleModalDismiss,
    handleMemberProfileModal,
    handleShowAgentModal,
    handleEmailVerifiedModalClose,
    handleEmailVerifiedModalOpen,
    handleEmailConfirmedModalClose,
    handleEmailConfirmedModalOpen,
    handleEmailChangeRevokedModalClose,
    handleEmailChangeRevokedModalOpen,
    handleCheckEmailDeletionModalClose,
    handleResetEmailModal,
    setDeleteNotificationModal,
    setWantAdRenewModal,

    // Business logic
    handleAgentTitleContinueClick,
    handleUserTypeContinueClick,
    handleResetPwdModal,
    handleAgentOnboardingModal,
    resetPassWord,
    handleUserLogin,
    updateIntroStateonHover,
    updateIntroPageOnScroll,
    handleCloseIntroList,
    getIntroductionList,
    handleHandShakeClick,
    getNotificationList,
    updateInAppStatusonHover,
    updateInAppDeleteStatusOnClick,
    onDeleteInappNotification,
    onConfirmReniewWantAdClicked,
    renewWantAd,
    handleTitleClick,
    handleUserTypeSelection,
    handlePreferenceSelection,
    saveAgentDetails,
    handleLogOut,
    updateReloadParam,
    renderEditProfileModel,
    setImage,
  };
};
